// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconCheck = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 16,
    width: 12,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-contract">
      <svg className="c-icon-contract fill-current" width={width || measurements.width} height={height || measurements.height} viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 8.79867L1.87975 6.17842L0.166504 7.89167L4.5 12.2252L11.8332 4.89192L10.12 3.17867L4.5 8.79867Z" fill={fill || '#EF8541'} />
      </svg>
    </Icon>
  );
};

export default IconCheck;
